import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CashPosition } from '../models/cash-position.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class CashPositionService {
  private http = inject(HttpClient);
  private base = `${apiBase}/cash-positions`;

  getAll(): Observable<CashPosition[]> {
    return this.http.get<CashPosition[]>(this.base);
  }

  getById(id: number): Observable<CashPosition> {
    return this.http.get<CashPosition>(`${this.base}/${id}`);
  }
}
